import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { MenuService } from 'src/app/services/menu.service';
import { MedicalOrderOperation } from 'src/app/model/medical-order-operation';

@Component({
  selector: 'app-billing-orden-control-operation',
  templateUrl: './billing-orden-control-operation.component.html',
  styleUrls: ['./billing-orden-control-operation.component.css']
})
export class BillingOrdenControlOperationComponent  implements OnInit {

  form: FormGroup;

  constructor(private formBuilder: FormBuilder
    , private route: ActivatedRoute
    , private  router: Router
    , private menuService: MenuService) {
  }

  setMedicalOrderOperation(medicalOrderId: number,
    protocol: string, medicalAppointmentId: number) {
    const medicalOrderOperation = new MedicalOrderOperation();
    medicalOrderOperation.MedicalOrderId = medicalOrderId;
    medicalOrderOperation.Protocol = protocol;
    medicalOrderOperation.MedicalApponitmentId = medicalAppointmentId;

    this.form = this.formBuilder.group({
      MedicalOrderOperation: [medicalOrderOperation]
    });
  }

  ngOnInit(): void {
    this.route.params.subscribe(async (params) => {
      const medicalOrderId = params['MedicalOrderId'];
      const protocol = params['Protocol'];
      const medicalApponitmentId = params['MedicalApponitmentId'];
      this.setMedicalOrderOperation(medicalOrderId,
        protocol, medicalApponitmentId);
    });
  }
}
